import { aesUtil } from '../../services/AESUtil';
import { AUTH_USER_LOGIN, AUTH_USER_SIGNIN_FROM_STORAGE, AUTH_USER_LOGOUT } from '../types/AuthType';
import moment from 'moment';

const initState = { token: null, userDetail: {}, userPermissions: {} };

export const AuthReducer = (state = initState, action) => {
    switch (action.type) {
        case AUTH_USER_LOGIN:
            let userProfileData = (action?.payload?.profile? JSON.parse(aesUtil.decrypt(action.payload.profile)) :{} )
            return {
                ...state,
                token: !action.error ? action.payload.token : state.token,
                userDetail: !action.error ? { ...userProfileData, 'lastLogin': moment() } : state.userDetail,
                userPermissions: !action.error ? action.payload.permission : state.userDetail
            }
        case AUTH_USER_SIGNIN_FROM_STORAGE:
            return {
                ...state,
                token: action.userInfo.token,
                userDetail: action.userInfo.userData,
                userPermissions: action.userInfo.userPermissions
            }
        case AUTH_USER_LOGOUT:
            return {
                ...state,
                token: null,
                userDetail: {},
                userPermissions: {}
            }
        default:
            return state;
    }
}